import { z } from 'zod';
import { getMeDtoSchema } from '../getMeDtoSchema';

export const usersControllerGetMe200Schema = z.lazy(() => getMeDtoSchema);

export const usersControllerGetMe401Schema = z.object({
  statusCode: z.enum(['401']),
  message: z.string(),
  type: z.enum(['Authentication']),
  details: z.object({
    reason: z.enum(['InvalidRequest', 'InvalidToken', 'Unauthorized']),
  }),
});

export const usersControllerGetMe403Schema = z.object({
  statusCode: z.enum(['403']),
  message: z.string(),
  type: z.enum(['Authorization']),
  details: z.object({ reason: z.enum(['InsufficientScope']) }),
});

export const usersControllerGetMeQueryResponseSchema = z.lazy(
  () => getMeDtoSchema,
);
